import { API_BASE_URL } from './apiBaseUrl';

export const Config = {
  api: {
    baseUrl: API_BASE_URL,
    timeout: 30000,
    // Saving a roster runs in a backend transaction allowed up to 30 s.
    teamSaveTimeout: 60000,
  },
  storage: {
    keys: {
      user: 'user',
      gameState: 'volley-stats-storage',
      interface: 'volley-stats-interface',
    },
  },
  match: {
    setsToWin: 3,
  },
  court: {
    positions: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6'] as const,
    zones: ['1', '2', '3', '4', '5', '6'] as const,
    backRowIndices: [0, 4, 5] as const,
  },
  pagination: {
    defaultPageSize: 20,
    maxPageSize: 100,
  },
} as const;

